<script>
import { EVENT_COMPONENT_ADD } from '../event-enums'

export default {
  name: 'CanvasDropCellPlugin',
  props: {
    length: Number, // 編輯器中的組件數量
    parentId: String // 父編輯器組件的ID
  },

  // 當組件掛載時添加拖曳事件監聽器
  mounted() {
    const element = this.$parent.getWrapperElement()
    element.addEventListener('dragover', this.handleDropOver, false)
    element.addEventListener('drop', this.handleDrop, false)
  },
  methods: {
    // 防止預設的瀏覽器拖曳行為
    handleDropOver(e) {
      e.preventDefault()
      e.stopPropagation()
    },

    // 將拖曳的檔案轉換為data URL
    getImageDataUrl(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e.target.result)
        }
        reader.readAsDataURL(file)
      })
    },

    // 處理組件拖曳事件
    async handleDrop(e) {
      e.preventDefault()
      e.stopPropagation()
      const addComponents = []
      let comstr = ''

      // 獲取編輯器元素尺寸來計算拖曳座標
      const rect = this.$parent.getWrapperElement().getBoundingClientRect()
      const coords = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      }

      // 處理被拖曳的組件資料
      if ((comstr = e.dataTransfer.getData('text/component'))) {
        let com = JSON.parse(comstr)
        // 將座標和PDF尺寸添加到組件資料中
        com = { ...com, ...coords, ...{ pdfWidth: rect.width, pdfHeight: rect.height } }
        console.log(com)
        addComponents.push(com)
      }

      // 觸發添加組件事件並傳遞新組件
      this.eventbus.$emit(EVENT_COMPONENT_ADD, { components: addComponents, parentId: this.parentId })
    }
  },

  // 如果沒有組件存在則渲染空的引導div
  render() {
    if (this.length > 0) return null
    return <div class="guide"></div>
  }
}
</script>
<style lang="less" scoped>
.guide {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  color: #999;
  line-height: 2;
  font-size: 16px;
  font-weight: 300;
}
</style>
